module.exports = __webpack_public_path__ + "static/media/Hfb_logo.09911730.png";